module.exports = __webpack_public_path__ + "static/media/logo-white.3a265af2.svg";